export default {"src":"/_next/static/media/MU.bb7bb62f.svg","height":18,"width":18};